import React from 'react'
import cn from 'classnames'
import Spinner from 'components/utils/Spinner'

import './permissions.less'

type PermissionUser = {
  id: string
  username?: string
  index?: number
  [key: string]: unknown
}

type PermissionsProps = {
  users?: PermissionUser[]
  creator?: PermissionUser | undefined
  readers?: Record<string, PermissionUser>
  writers?: Record<string, PermissionUser>
  showText?: boolean
}

const Permissions = ({ users: usersProp, creator, readers: readersProp, writers: writersProp, showText }: PermissionsProps) => {
  const users = usersProp || []
  const writers = writersProp || {}
  const readers = readersProp || {}

  const getTitle = () => {
    const creatorText = creator?.username ? creator.username : ''
    const readersText = Object.values(readers).map((user) => user.username || 'loading...').join(', ')
    const writersText = Object.values(writers).map((user) => user.username || 'loading...').join(', ')
    const usersText = users.map((user) => user.username || 'loading...').join(', ')
    const titleParts: string[] = []
    if (creatorText) {
      titleParts.push(`(creator: ${creatorText})`)
    }
    if (writersText) {
      titleParts.push(`(writers: ${writersText})`)
    }
    if (readersText) {
      titleParts.push(`(readers: ${readersText})`)
    }
    if (usersText) {
      titleParts.push(`(${usersText})`)
    }
    return titleParts.join(' ')
  }

  let allUsers: PermissionUser[] = []
  if (creator) {
    allUsers.push(creator)
  }
  if (users) {
    allUsers = allUsers.concat(users)
  }
  Object.values(writers).forEach((user) => allUsers.push(user))
  Object.values(readers).forEach((user) => {
    if (!writers[user.id]) {
      allUsers.push(user)
    }
  })
  let arity = 'arity-many'
  if (allUsers.length < 3) {
    arity = `arity-${allUsers.length}`
  }
  if (!allUsers.length) {
    return null
  }
  const usersText = (() => {
    const firstUser = allUsers[0]
    switch (allUsers.length) {
      case 0:
        return ''
      case 1:
        return firstUser?.username || ''
      default:
        return `${firstUser?.username || ''}, +${allUsers.length - 1}`
    }
  })()

  return (
    <div className={cn('permissions-wrapper')}>
      <div className={cn('permissions')} title={getTitle()}>
        {allUsers.map((user: PermissionUser, i: number) => {
          if (i > 2) {
            return null
          }
          const n = user.username?.[0] || ''
          return (
            <div key={user.id} className={cn('permission', arity, `background-permission-${user.index}`)}>
              <span className={cn('permission-content', { plusOne: i === 2 })}>
                {i === 2 ? `+${allUsers.length - i}` : n !== '' ? n : <Spinner show />}
              </span>
            </div>
          )
        })}
      </div>
      {showText ? <span className={cn('users-text')}>{usersText}</span> : null}
    </div>
  )
}

export default Permissions
